import { Stack, Typography } from '@mui/material';
import { Button } from '@/components/navigation/NavigationIntroScreen/components/Popup/styles';
import {
  CornerUpRitghtIcon,
  SmartphoneIcon,
} from '@/components/navigation/NavigationIntroScreen/components/Popup/Icons';
import { useNavigationStore } from '../../../../../../store';

type Props = {
  isMobile: boolean;
  buttonsDisabled: boolean;
  onConfirm: (item: any) => void;
  setSharePopupOpen: (open: boolean) => void;
  sharingEnabled: boolean;
  rtl: boolean;
};

export const ButtonsContainer = ({
  isMobile,
  buttonsDisabled,
  onConfirm,
  setSharePopupOpen,
  sharingEnabled,
  rtl,
}) => {
  const translation = useNavigationStore((state) => state.navigationTranslation);

  return (
    <Stack
      id="buttons-container"
      sx={{
        position: isMobile ? 'absolute' : 'sticky',
        bottom: 0,
        left: isMobile ? 0 : undefined,
        background: '#fff',
        width: isMobile ? '100%' : 'auto',
        p: isMobile ? '14px 12px 30px 12px' : '14px',
        zIndex: 9999,
        userSelect: 'none',
      }}
    >
      <Button
        disabled={buttonsDisabled}
        onClick={onConfirm}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '10px',
          direction: rtl ? 'rtl' : 'ltr',
          height: '40px',
          opacity: buttonsDisabled ? 0.5 : 1,
          cursor: buttonsDisabled ? 'not-allowed' : 'pointer',
        }}
      >
        <CornerUpRitghtIcon style={{ width: '20px', height: '20px' }} />
        <Typography sx={{ direction: rtl ? 'rtl' : 'ltr', fontWeight: rtl ? 500 : 600 }}>
          {translation.navGetDirections || 'Get directions'}
        </Typography>
      </Button>
      {sharingEnabled && (
        <Button
          onClick={() => setSharePopupOpen(true)}
          disabled={buttonsDisabled}
          style={{
            display: isMobile ? 'none' : 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            background: '#FFFFFF',
            color: '#2055FF',
            marginTop: '10px',
            border: '1px solid #D0D5DD',
            direction: rtl ? 'rtl' : 'ltr',
            height: '40px',
            opacity: buttonsDisabled ? 0.5 : 1,
            cursor: buttonsDisabled ? 'not-allowed' : 'pointer',
          }}
        >
          <SmartphoneIcon style={{ width: '20px', height: '20px' }} />
          <Typography sx={{ direction: rtl ? 'rtl' : 'ltr', fontWeight: rtl ? 500 : 600 }}>
            {translation.navShareToPhone || 'Share to your phone'}
          </Typography>
        </Button>
      )}
    </Stack>
  );
};
